import globals from '../globals';
import helpers from '../helpers';

function getHeight() {
	return $('.header__top').outerHeight();
}

function init() {
	let button = $('.header__select');
	let popup = $('.popup-region');
	let close = $('.popup-region__close');

	const $moreButton = $('.more-link');
	const $more = $('.more');

	button.on('click', () => {
		popup.toggleClass('is-hidden');
	});

	close.on('click', () => {
		popup.toggleClass('is-hidden');
	});

	if (!helpers.isMobile()) {
		$moreButton.on('click', (e) => {
			e.preventDefault();

			$more.toggleClass('is-hidden');

			const left = $moreButton.offset().left - $more.width() + 50;

			$more.css({
				left,
			});
		});

		globals.$document.on('mouseup', (e) => {
			if (!$moreButton.is(e.target)
				&& $moreButton.has(e.target).length === 0 && !$more.is(e.target)
				&& $more.has(e.target).length === 0) {
				$more.addClass('is-hidden');
			}
		});
	}
}

function menu() {
	let button = $('.header__menu');
	// eslint-disable-next-line no-shadow
	let menu = $('.header__nav-inner');
	let close = $('.menu-close');
	let open = $('.menu-open');

	button.on('click', () => {
		menu.toggleClass('is-hidden');
		close.toggleClass('is-hidden');
		open.toggleClass('is-hidden');
	});
}

init();
menu();

export default {
	getHeight,
};
